// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3SkVp","col":"styles_col__2zeR9"};